import { TIPO_OPERACION } from '../../../services/api/alojamientoProveedorApi';

export const GESTION_ALOJAMIENTO_MODOS = {
  reserva: {
    key: 'reserva',
    title: 'Gestión de Reservas',
    subtitle:
      'Consulta por estado y fechas, exporta a Excel, completa fechas de estadía y sincroniza reservas con Logiflex',
    defaultEstadoNombre: '',
    defaultCampoFecha: 'reserva',
    tipoOperacion: TIPO_OPERACION.RESERVA,
    showFechasEstadia: true,
    showHomologacion: true,
    prereqColumn: null,
    prereqLabel: '',
    syncHelpText:
      'requiere estado reservada u ocupada (regularización), activo=1, cama homologada y fechas de estadía',
    emptyText: 'No hay reservas con los filtros aplicados',
    excelSheet: 'Reservas',
    excelPrefix: 'Gestion_Reservas',
    entityLabel: 'reserva',
    entityLabelPlural: 'reservas',
    resumenHint:
      'Marque filas y use Sync selección para enviar a Logiflex, o Completar fechas / botón Fechas por fila.',
  },
  checkin: {
    key: 'checkin',
    title: 'Gestión de Check-in',
    subtitle:
      'Asignaciones ocupadas con check-in — filtros, exportación y sincronización de check-in con Logiflex',
    defaultEstadoNombre: 'ocupada',
    defaultCampoFecha: 'check_in',
    tipoOperacion: TIPO_OPERACION.CHECKIN,
    showFechasEstadia: false,
    showHomologacion: true,
    prereqColumn: null,
    prereqLabel: '',
    syncHelpText:
      'requiere estado ocupada, activo=1 y fecha de check-in; no depende de una reserva sincronizada en Logiflex',
    emptyText: 'No hay check-in con los filtros aplicados',
    excelSheet: 'Check-in',
    excelPrefix: 'Gestion_CheckIn',
    entityLabel: 'check-in',
    entityLabelPlural: 'check-in',
    resumenHint:
      'Marque filas y use Sync selección para enviar check-in a Logiflex. No requiere reserva previa sincronizada.',
  },
  checkout: {
    key: 'checkout',
    title: 'Gestión de Check-out',
    subtitle:
      'Asignaciones finalizadas con check-out — filtros, exportación y sincronización de check-out con Logiflex',
    defaultEstadoNombre: 'finalizada',
    defaultCampoFecha: 'check_out',
    tipoOperacion: TIPO_OPERACION.CHECKOUT,
    showFechasEstadia: false,
    showHomologacion: true,
    prereqColumn: 'checkin_sincronizado',
    prereqLabel: 'Check-in previo',
    syncHelpText:
      'requiere estado finalizada, fecha de check-out, check-in previo sincronizado en Logiflex y cama homologada',
    emptyText: 'No hay check-out con los filtros aplicados',
    excelSheet: 'Check-out',
    excelPrefix: 'Gestion_CheckOut',
    entityLabel: 'check-out',
    entityLabelPlural: 'check-out',
    resumenHint:
      'Marque filas y use Sync selección para enviar check-out a Logiflex. El check-in previo debe estar sincronizado.',
  },
};

export const puedeSincronizarFila = (row, config) =>
  Boolean(row.puede_sincronizar ?? row.puede_sincronizar_reserva);

export const bloqueoSincronizacionFila = (row, config) =>
  row.bloqueo_sincronizacion ?? row.bloqueo_sincronizacion_reserva ?? '';
